import { DialogActions, DialogContent, useMediaQuery, useTheme } from '@mui/material'
import IconButton from '@mui/material/IconButton'
import { useTranslation } from 'react-i18next'
import React, { useState } from 'react'

import { ArrowBackIos } from '@mui/icons-material'
import ContainedButton from '../Buttons/ContainedButton'
import CustomDialog from '../CustomDialog'

interface Props {
   imagesLinks: string[]
   open: boolean
   handleClose: () => void
}

export default function PhotoBrowser({ open, handleClose, imagesLinks }: Props) {
   const [imageIndex, setImageIndex] = useState(0)
   const theme = useTheme()
   const { t } = useTranslation('TRANSLATION')
   const isMobile = useMediaQuery(theme.breakpoints.down('md'))

   function nextPhoto() {
      if (imageIndex === imagesLinks.length - 1) {
         setImageIndex(0)
      } else setImageIndex((prevState) => prevState + 1)
   }

   function prevPhoto() {
      if (imageIndex === 0) {
         setImageIndex(imagesLinks.length - 1)
      } else setImageIndex((prevState) => prevState - 1)
   }

   return (
      <CustomDialog
         isLoading={!open}
         maxWidth="lg"
         open={open}
         onClose={handleClose}
         content={
            <>
               <DialogContent sx={{ display: 'flex', p: 0 }}>
                  <IconButton
                     onClick={prevPhoto}
                     disabled={imagesLinks.length === 0 || imagesLinks.length === 1}
                     sx={{ alignSelf: 'center' }}
                  >
                     <ArrowBackIos />
                  </IconButton>
                  <img
                     style={{ userSelect: 'none', maxHeight: isMobile ? 360 : 400, width: 'auto' }}
                     src={`${process.env.REACT_APP_FILES_URL}/assets/producers/${imagesLinks[imageIndex]}`}
                     alt="partPhoto"
                  />
                  <IconButton
                     sx={{ transform: 'rotate(180deg)', alignSelf: 'center' }}
                     onClick={nextPhoto}
                     disabled={imagesLinks.length === 0 || imagesLinks.length === 1}
                  >
                     <ArrowBackIos />
                  </IconButton>
               </DialogContent>
               {isMobile && (
                  <DialogActions>
                     <ContainedButton variant="contained" onClick={handleClose}>
                        {t('TRANSLATION:close')}
                     </ContainedButton>
                  </DialogActions>
               )}
            </>
         }
      />
   )
}
